import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'

function MySettingsPopin({ closeModal = false, connectionType = '', handleMySettings }) {
  const { t } = useTranslation()

  return (
    <div className={styles.mySettingsPopin}>
      <h2 className={styles.title}>{t('event.create.venue.connection', { connection: `"${connectionType}"` })}</h2>
      <div className={styles.buttonWrapper}>
        <Button size='large' text={t('global.cancel')} style='secondary' handleClick={closeModal} />
        <Button size='large' text={t('global.goToMySettings')} handleClick={handleMySettings} />
      </div>
    </div>
  )
}

export default MySettingsPopin
